/**
 * Loads i18next translation resources from JSON files. Uses static imports so
 * the build includes the JSON files. To add a locale or namespace, add the
 * import below and extend LOCALES/I18nNamespace.
 */

import { ALL_LOCALES, Locale } from "./locales";
import { ALL_NAMESPACES, type I18nNamespaceType } from "./namespaces";

type ModuleKey = `${Locale}/${I18nNamespaceType}`;
type TranslationRecord = Record<string, string>;

import enI18n from"./en/i18n.json"
import enWeb from"./en/web.json"
import enReturnApp from"./en/return-app.json"
import enModel from"./en/model.json"
import enCustomerPortal from"./en/customer-portal.json"
import enCustomerPortalShared from"./en/customer-portal-shared.json"
import esI18n from"./es/i18n.json"
import esWeb from"./es/web.json"
import esReturnApp from"./es/return-app.json"
import esModel from"./es/model.json"
import esCustomerPortal from"./es/customer-portal.json"
import esCustomerPortalShared from"./es/customer-portal-shared.json"
import frI18n from"./fr/i18n.json"
import frWeb from"./fr/web.json"
import frReturnApp from"./fr/return-app.json"
import frModel from"./fr/model.json"
import frCustomerPortal from"./fr/customer-portal.json"
import frCustomerPortalShared from"./fr/customer-portal-shared.json"

const modules: Record<ModuleKey, TranslationRecord> = {
  "en/i18n": enI18n,
  "en/web": enWeb,
  "en/return-app": enReturnApp,
  "en/model": enModel,
  "en/customer-portal": enCustomerPortal,
  "en/customer-portal-shared": enCustomerPortalShared,
  "es/i18n": esI18n,
  "es/web": esWeb,
  "es/return-app": esReturnApp,
  "es/model": esModel,
  "es/customer-portal": esCustomerPortal,
  "es/customer-portal-shared": esCustomerPortalShared,
  "fr/i18n": frI18n,
  "fr/web": frWeb,
  "fr/return-app": frReturnApp,
  "fr/model": frModel,
  "fr/customer-portal": frCustomerPortal,
  "fr/customer-portal-shared": frCustomerPortalShared,
};

export function getI18nResources(): Record<
  string,
  { translation: TranslationRecord }
> {
  const resources: Record<string, { translation: TranslationRecord }> = {};
  for (const locale of ALL_LOCALES) {
    resources[locale] = { translation: {} };
    for (const namespace of ALL_NAMESPACES) {
      const data = modules[`${locale}/${namespace}`];
      if (data) {
        Object.assign(resources[locale].translation, data);
      }
    }
  }
  return resources;
}
